import BatteryController from './BatteryController';
import Benchmark from './Benchmark';
import Illustration from './Illustration';

const RangeCalculator = ({ title }) => `
    <article id="range-calculator" class="range-calculator reveal" role="article">
        <h2>${title}</h2>
        ${Illustration()}
        ${Benchmark()}
        ${BatteryController()}
    </article>
`;

export default RangeCalculator;
